<template>
    <button type="button" disabled @click="handleBuyNow()">
        {{ aliasTranslations.buy_now || $t("carts.buyNow") }}
    </button>
</template>
  
<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from "vue-i18n"
import { lookupAliasTranslations } from "../../utils"

const props = defineProps({
    storeData: Object,
})

const { t, n, locale } = useI18n()

const store = useStore()
const storeData = computed(() => props.storeData ?? {})
const aliasTranslations = computed(() => lookupAliasTranslations(storeData.value.alias_translations, locale.value) ?? {})

const handleBuyNow = () => {
    window.addToCart('add-to-cart-form', false, (response) => {
        console.log("handleBuyNow", response);
        store.dispatch('lite/openCheckoutDialog');
    });
}
</script>
  